import axios from 'axios';
import * as Joi from 'joi';
import 'antd/dist/antd.css';
import { Card, Col, Layout, Row, Spin } from 'antd';

import './App.css';
import { useEffect, useState } from 'react';

import Header from './components/Header/Header';
import Content from './components/Content/Content';
import { useTranslation } from 'react-i18next';

const carrierConfigSchema = Joi.object({
  locale: Joi.string().required(),
  phoneCountryCode: Joi.string().optional(),
  defaultLanguage: Joi.string().required(),
  timezone: Joi.string().required(),
  guide: Joi.string().required(),
  carrier: Joi.object({
    logoSrc: Joi.string().required(),
    name: Joi.string().required(),
    warehouses: Joi.array().items(
      Joi.object({
        id: Joi.number().required(),
        value: Joi.string().required(),
      }),
    ),
  }),
  locizeOverride: Joi.object({
    card: Joi.object({
      title: Joi.string().optional(),
    }).optional(),
  }).optional(),
});

function App() {
  const [carrierKey, setCarrierKey] = useState();
  const [carrierConfig, setCarrierConfig] = useState();

  const { t: translate } = useTranslation('carrierSignup');

  useEffect(() => {
    setTimeout(() => {
      const hostItems = window.location.host.split('.');
      if (hostItems.length === 3) setCarrierKey(hostItems[0]);
      // For local debug purpose
      else if (hostItems.length && hostItems[0].startsWith('localhost')) setCarrierKey('default');
      else setCarrierConfig(new Error('Invalid hostname'));
    }, 500);
  }, []);

  useEffect(() => {
    carrierKey &&
      axios
        .get(`https://byways-carrier-signup.s3.eu-central-1.amazonaws.com/${carrierKey}.json?ts=${Date.now()}`)
        .then((res) => {
          const validate = carrierConfigSchema.validate(res.data);
          if (validate.error) setCarrierConfig(validate.error);
          else setCarrierConfig(validate.value);
        })
        .catch((error) => {
          console.error(error);
          setCarrierConfig(error);
        });
  }, [carrierKey]);

  return (
    <div className='App'>
      <Layout className='layout'>
        <Spin spinning={!carrierConfig}>
          {!carrierConfig ? (
            <Row type='flex' justify='center' align='middle' style={{ minHeight: '100vh' }}>
              <Col span={4}>
                <Card style={{ width: 300 }}>
                  <p>{translate('loading')}.</p>
                </Card>
              </Col>
            </Row>
          ) : carrierConfig instanceof Error ? (
            <Row type='flex' justify='center' align='middle' style={{ minHeight: '100vh' }}>
              <Col span={4}>
                <Card style={{ width: 300 }}>
                  <p>
                    {translate('incorrectURL.title')}.
                    <br />
                    {translate('incorrectURL.checkOrTryLater')}.
                  </p>
                </Card>
              </Col>
            </Row>
          ) : (
            <>
              <Header />
              <Content carrierConfig={carrierConfig} />
              <Layout.Footer className='footer'>byways, 2022</Layout.Footer>
            </>
          )}
        </Spin>
      </Layout>
    </div>
  );
}

export default App;
